import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
const Columns = _ref => {
  let {
    color = '#335B70',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M0.001 3.765v24.47h32v-24.47h-32zM18.824 7.529v16.941h-5.647v-16.941h5.647zM3.765 7.529h5.647v16.941h-5.647v-16.941zM28.236 24.471h-5.647v-16.941h5.647v16.941z"
  }));
};
export default Columns;